import React from 'react';

import PropTypes from 'prop-types';

import { NetworkConnectionSubText } from 'components/ExpertSearch/components/NetworkConnectionSubText/NetworkConnectionSubText';

import './NetworkConnectionSubtitle.scss';

export const NetworkConnectionSubtitle = ({
  description,
  descriptionEmail,
  descriptionAfterEmail = '',
}) => (
  <div className="networkConnectionSubtitle">
    <NetworkConnectionSubText text={description} textEmail={descriptionEmail} textAfterEmail="." />

    {descriptionAfterEmail && <NetworkConnectionSubText text={descriptionAfterEmail} />}
  </div>
);

NetworkConnectionSubtitle.propTypes = {
  description: PropTypes.string,
  descriptionEmail: PropTypes.string,
  descriptionAfterEmail: PropTypes.string,
};

NetworkConnectionSubtitle.defaultProps = {
  description: '',
  descriptionEmail: '',
  descriptionAfterEmail: '',
};
